import React from 'react'

const Purchased = () => {
  return (
    <div>
      
    </div>
  )
}

export default Purchased
